


















import { Component, Prop } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { ConsumptionReason, StructuredResult } from '@/dto';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import DataSource from 'devextreme/data/data_source';
import { ContextsState } from '@/store';
import { Table, TableOptions, getTableCaption } from '@/core/components/table';
import { Page } from '@/core/components/controls';
import {
    FetchServiceContract,
    CONTRACTS,
    EventsServiceContract,
    Events
    } from '@/core/contracts';
import { ConsumptionReasonPageArgs } from './types';
import { lookupField } from '@/core/helpers';
import { localize } from '@/core/filters';
import ConsumptionReasonTable from './ConsumptionReasonTable.vue';

@Component({
    components: {
        ConsumptionReasonTable,
        TableOptions,
    },
})
export default class ConsumptionReasonPage extends Page {
    @Prop({ default: () => ({}) }) public args!: ConsumptionReasonPageArgs;
    public table: Table | null = null;
    public tableKey: string = 'consumption-reason-control';

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    public setTable(table: Table): void {
        this.table = table;
    }

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get dataSource(): DataSource {
        return new DataSource({
            load: this.load,
        });
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.table!.refresh();
        }
    }

private async load() {
        const currentContextId = ContextsState.currentContextId;
        const url = `/contexts/${this.args!.contextId}/consumptions/${
            this.args!.packAlias
        }/reason-consumption`;
        return this._fetchService!.get<StructuredResult<ConsumptionReason>>(url).then(
            (data: StructuredResult<ConsumptionReason>) => {
                if (!data) {
                    return {
                        data: [],
                        totalCount: 0,
                    };
                }
                this.transform(data);

                const items = data.items || [];

                return {
                    data: items,
                    totalCount: items.length,
                };
            }
        );
    }

private transform(data: StructuredResult<ConsumptionReason>) {
        if (!(data && data.items)) {
            return;
        }

        for (const item of data.items) {
            lookupField(item, 'site', data.sites);
            lookupField(item, 'vehicleType', data.resourceTypes);
            lookupField(item, 'productType', data.resourceTypes);
            lookupField(item, 'channel', data.channels);
            if (item.operation) {
                item.operation = localize(`EventType_${item.operation}`);
            }
            item.type = localize(`Reason_${item.type}`);
        }
    }
}
